import React, { act, useState } from "react";
import logo from "../../assets/img/logoPro.png"; // Make sure path is correct
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import useApiRequest from "../../Hooks/apiReq";
import { validateOTP } from "../../Validation/OTPValidation";
import Loader from "../Loader";

const OtpVerification = () => {
  const OTPResponce = useSelector((state) => state.uiReducers.otpResponce);
  const loginid = useSelector((state) => state.uiReducers.loginid);
  const navigate = useNavigate();
  const { error, loading, recallRequest, response, sendApiRequest, status } =
    useApiRequest();
  const [OTP, setOTP] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    otp6: "",
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    const cleanValue = value.replace(/[^0-9]/g, "").slice(0, 1); // only 1 digit
    setOTP((prev) => ({ ...prev, [id]: cleanValue }));
    if (cleanValue) {
      const nextIndex = parseInt(id.replace("otp", "")) + 1;
      const nextInput = document.getElementById(`otp${nextIndex}`);
      nextInput?.focus();
    }
  };
  const handleVerifyOTP = () => {
    const otp = `${OTP.otp1}${OTP.otp2}${OTP.otp3}${OTP.otp4}${OTP.otp5}${OTP.otp6}`;
    if (validateOTP(OTP)) {
      sendApiRequest(
        "POST",
        "/Auth/forget-password",
        {
          strAssociateCode: loginid,
          strOTP: otp,
          action: "VerifyOTP",
        },
        {
          onSuccess: (res) => {
            toast.success(res.Message);
            navigate(`/change-password`, { replace: true });
          },
        }
      );
    }
  };
  const handleKeyDown = (e) => {
    const { id, value } = e.target;
    const index = parseInt(id.replace("otp", ""));
    if (e.key === "Backspace" && !value && index > 1) {
      const prevInput = document.getElementById(`otp${index - 1}`);
      prevInput?.focus();
    }
    if (e.key === "Enter") {
      handleVerifyOTP();
    }
  };
  // console.log(OTPResponce)
  return (
    <div className="container">
      <div className="row flex-center min-vh-100 py-5">
        <div className="col-sm-10 col-md-8 col-lg-5 col-xxl-4">
          <a className="d-flex flex-center text-decoration-none mb-4">
            <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
              <img src={logo} alt="phoenix" width="158" />
            </div>
          </a>
          <div className="px-xxl-5">
            <div className="text-center mb-6">
              <h4 className="textColor">Enter the verification code</h4>
              <p className="  mb-5 textColor">
                6-digit verification code has been sent to the mobile number
                ******{OTPResponce?.mobileNo.slice(6, 10)}{" "}
                <Link to="/forget-password">Change</Link>
              </p>
              {/* <p className="fs-10 mb-5">
                Don’t have access? <a href="#!">Use another method</a>
              </p> */}

              <div className="verification-form" data-2fa-form="data-2fa-form">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    id="otp1"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    id="otp2"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    id="otp3"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                  <span>-</span>
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    id="otp4"
                  />
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    id="otp5"
                  />{" "}
                  <input
                    className="form-control px-2 text-center"
                    type="number"
                    maxLength={1}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    id="otp6"
                  />
                </div>

                {/* <div className="form-check text-start mb-4">
                  <input
                    className="form-check-input"
                    id="2fa-checkbox"
                    type="checkbox"
                  />
                  <label htmlFor="2fa-checkbox">
                    Don’t ask again on this device
                  </label>
                </div> */}

                <button
                  className="btn btn-primary w-100 my-4"
                  onClick={handleVerifyOTP}
                >
                  Verify
                </button>
                {/* <a className="fs-9" href="#!">
                  Didn’t receive the code?
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default OtpVerification;
